var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('i',{staticClass:"under-development"}),_c('div',{staticClass:"text"},[_vm._v("正在开发中")])])
}]

export { render, staticRenderFns }